<template>
  <div class="report-office-pattern">
    <v-text-field
      :label="schema.title"
      :value="selectedInfo"
      :class="{ 'background-dark': schema.dark }"
      readonly
      @click.native="toggleModal"
    />

    <v-dialog
      v-model="showPicker"
      max-width="680px"
      content-class="fixed-height-md"
    >
      <modal-card
        :title="schema.title"
        padding
        full
        fixed
        :loading="loading"
        @close="showPicker = false"
      >
        <office-patter-picker
          v-model="selectedOffice"
          :patterns="officePatterns"
          @close="showPicker = false"
        />
      </modal-card>
    </v-dialog>
  </div>
</template>

<script>
import OfficePatterPicker from './OfficePatternPicker';
import { mapActions, mapGetters } from 'vuex';

const REPORT_KEY = 'officePatterns';

export default {
  name: 'ReportOfficePattern',
  components: {
    OfficePatterPicker,
  },
  props: {
    value: {},
    schema: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showPicker: false,
    };
  },
  computed: {
    ...mapGetters('reports', ['byId', 'loading']),
    selectedOffice: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
        this.showPicker = false;
      },
    },
    officePatterns() {
      const patterns = this.byId(REPORT_KEY);
      return patterns?.data || [];
    },
    selectedInfo() {
      if (!this.value) return;
      let office = this.officePatterns.find(({ pattern }) => {
        return pattern == this.value;
      });
      return office ? `${office.label}/${office.pattern}` : this.value;
    },
  },
  methods: {
    toggleModal() {
      this.showPicker = !this.showPicker;
    },
    ...mapActions('reports', ['loadOne']),
    async loadResources() {
      let params = this.schema?.params || {};
      params.data = 1;

      await this.loadOne({
        path: this.getReportPath(),
        params,
      });
    },

    getReportPath() {
      const sharePid = this.schema?.pid;

      let path = REPORT_KEY;
      if (sharePid) {
        path = `shared/${sharePid}/${path}`;
      }
      return path;
    },
  },
  mounted() {
    this.loadResources();
  },
};
</script>

<style lang="less">
.report-office-pattern {
  & > .v-input {
    .v-input__slot,
    input {
      cursor: pointer;
    }
  }
}
</style>
